import AuthModal from "@/Components/Common/Auth/AuthModal";
import Navbar from "@/Components/Layout/Navbar";
import {
  useQuery
} from "@tanstack/react-query";
import { useEffect, useState } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./Components/Common/Loader";
import CommonModal from "./Components/Common/modal/Modal";
import ErrorBoundary from "./Components/ErrorBoundry/ErrorBoundary";
import Footer from "./Components/Layout/Footer";
import TopHeader from "./Components/Layout/TopHeader";
import { ThemeProvider } from "./Context/ThemeProvider";
import { makeRequest } from "./helpers/apiWrapper";
import { useCountryLocation } from "./hooks/useDetectIpCountry";
import ProductDetails from "./Pages/Products/ProductDetails";
import { approuter } from "./Routers/Routes";
import { useCountriesQuery } from "./Store/CountryStore";
import { CategoryNode, useDashboardStore } from "./Store/DashboardStore";
import { useUserStore } from "./Store/UserInfoStore";
import useWishlistStore from "./Store/wishlistStore";
import ScrollToTop from "./Components/Layout/ScrollToTop";
function AppWrapper() {
  const [error, setError] = useState("");
  const { setUser, setIsLoading, user } = useUserStore();
  const { setWallet } = useDashboardStore.getState();
  const { setCategories } = useDashboardStore();
  const { clearWishlist, addToWishlist } = useWishlistStore();
  const categoriesQuery = useQuery({
    queryKey: ["Categories"],
    queryFn: () =>
      makeRequest({ endpoint: "/api/category/get-categories" }).then((dec) => {
        setCategories(dec?.data as CategoryNode[]);
        return dec.data;
      }),
  });
  const { isLoading } = useCountriesQuery();
  const { isLoading: locationLoading } = useCountryLocation();

  const wishlistQuery = useQuery({
    queryKey: ["wishlist"],
    queryFn: () =>
      makeRequest({
        endpoint: "/api/product/get-wishlist",
        method: "GET",
      }).then((res) => res.data),
    enabled: !!user?._id,
  });


  useEffect(() => {
    if (wishlistQuery.data?.products) {
      clearWishlist();
      wishlistQuery.data.products.forEach((product: any) => {
        addToWishlist(product);
      });
    }
  }, [wishlistQuery.data, clearWishlist, addToWishlist]);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userInfo = await makeRequest({
          endpoint: "/api/auth/get-account",
        }).then((data) => data.data);
        setUser(userInfo);
      } catch (err: any) {
        const combinedMessage = `${err.message}${err?.errorId ? ` — ${err?.errorId}` : ""
          }`;
        setError(combinedMessage);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [setUser, setIsLoading]);

  const userWalletsQuery = useQuery({
    queryKey: ["UserWallets", user?._id],
    queryFn: async () => {
      if (!user?._id) return null;
      const response = await makeRequest({
        endpoint: `/api/wallet/get-user-wallet/${user._id}`,
        server: "main",
      });
      setWallet(response.walletList);
      return response;
    },
    enabled: !!user?._id,
  });

  const showLoader = categoriesQuery?.isLoading || isLoading || locationLoading;

  return (
    <ThemeProvider>
      {showLoader && <Loader />}
      <BrowserRouter>
        <ScrollToTop />
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </ThemeProvider>
  );
}

function App() {
  const location = useLocation();

  return (
    <>
      {!location.pathname.startsWith("/dashboard") &&
        !location.pathname.startsWith("/login") &&
        !location.pathname.startsWith("/signup") && (
          <div className="">
            <TopHeader />
          </div>
        )}
      {!location.pathname.startsWith("/dashboard") &&
        !location.pathname.startsWith("/login") &&
        !location.pathname.startsWith("/signup") && (
          <div className="">
            <Navbar />
          </div>
        )}

      {/* 
      <div className="fixed right-2 top-[90%] z-10">
        <InstapaySign />
      </div> */}
      <ToastContainer position="top-right" autoClose={1000} />

      {/* <AuthModal /> */}
      <CommonModal />
      <div>
        <Routes>
          {approuter.map((r, idx) => (
            <Route key={idx} path={r.path} element={r.element}>
              {r.children?.map((child, cidx) => (
                <Route key={cidx} path={child.path} element={child.element} />
              ))}
            </Route>
          ))}

          <Route path="/product/:productId" element={<ProductDetails />} />
        </Routes>
        {!(
          location.pathname.startsWith("/dashboard") ||
          location.pathname.startsWith("/login") ||
          location.pathname.startsWith("/signup")
        ) && <Footer />}
      </div>
    </>
  );
}

export default AppWrapper;
